import {BoxProps, Button, Text, VStack} from "@chakra-ui/react";
import {ReactNode} from "react";
import {shaddow} from "../styling";

type EmptyStateProps = {
    title: string
    desc: string
    icon?: string
    children?: ReactNode
};
type L5ButtonProps = {
    isDisabled?: boolean
    children: ReactNode
    onClick: () => void
    type: "primary" | "secondary" | "danger" | "warning" | "info"
};
type L5Props = {variant?:string,border?:string,color?: string,scheme?: string};
type CloserProps = {
    onClose: VoidFunction
    mt?: string
    mb?: string
    h?: string
    w?: string
    size?: number
    alignSelf?: string
};
const buttonStyle: Record<L5ButtonProps["type"], L5Props> = {
    danger: {scheme: "red"},
    info: {scheme: "purple"},
    primary: {},
    secondary: {color: "primary.500", border: "primary.500", variant: "outline"},
    warning: {scheme: "orange"}
};

export function ListContainer(props: {children: ReactNode} & BoxProps) {
    const p = Object.assign({}, props);
    delete p.children;
    return <VStack
        {...p}
        borderRadius={{base: 0, md: "1.5rem 1.5rem 0 0"}}
        borderBottomRadius="none"
        h={props.h ?? {base: `calc(100lvb - 190px)`, md: `calc(100lvb - 160px)`}}
        minW={props.minW ?? "min(375px, 100%)"}
        boxShadow={props.boxShadow ?? shaddow}
        isolation="isolate"
        gap={props.gap ?? ".5rem"}
        p={props.p ?? "0 0 .5rem"}
    >
        {props.children}
    </VStack>;
};

export function EmptyState(props: EmptyStateProps & BoxProps & {hideIcon?: boolean}) {
    return <ListContainer
        alignItems={props.alignItems ?? "center"}
        justifyContent={props.justifyContent ?? "center"}
        color="dark.200"
        lineHeight="22px"
        maxW={props.maxW ?? "375px"}
        gap={props.gap ?? ".75rem"}
        p={props.p ?? "1rem 2rem"}
        boxShadow={props.boxShadow}
        h={props.h}
    >
        {!props.hideIcon && <svg width="130" height="130" aria-hidden="true">
            <use xlinkHref={`#${props.icon ?? "cone"}`} />
        </svg>}
        <Text fontSize="18px" fontWeight="bold" textAlign="center">
            {props.title}
        </Text>
        <Text fontSize="16px" textAlign="center" style={{textWrap: "pretty"}}>{props.desc}</Text>
        {props.children}
    </ListContainer>;
};


export function CustomCloserButton(props : CloserProps) {
    const s = `${props.size ?? "20"}`;
    return <Button
        mt={props.mt}
        mb={props.mb}
        alignSelf={props.alignSelf}
        onClick={props.onClose}
        variant="unstyled"
        placeItems="center"
        color="dark.200"
        _hover={{ cursor: "pointer" }}
    >
        <svg width={s} height={s}><use xlinkHref="#x_close"/></svg>
    </Button>;
}

export function L5Button(props: L5ButtonProps & BoxProps) {
    const p: Record<string, any>= Object.assign({}, props);
    let style = buttonStyle[props.type];
    delete p.type;
    return <Button
        {...p}
        h="40px"
        borderRadius={props.borderRadius ?? "8px"}
        color={style.color}
        flex={props.flex ?? "0 0 auto"}
        colorScheme={style.scheme ?? "primary"}
        variant={style.variant ?? "solid"}
        onClick={props.onClick}
        borderColor={style.border ?? "transparent"}
        isDisabled={props.isDisabled}
        transition="all .35s ease"
    >
        {props.children}
    </Button>;
}

